import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { InputComponent } from './input.component';

import { PizarraModule } from '@app/objetos-comunes/pizarra/pizarra.module';

@NgModule({
   declarations: [ InputComponent ],
   imports: [
      CommonModule,
      PizarraModule
   ],
   exports: [ InputComponent ]
})
export class InputModule { }
